import { render, staticRenderFns } from "./WordDetailMobile.vue?vue&type=template&id=1a891efa&scoped=true&"
import script from "./WordDetailMobile.vue?vue&type=script&lang=js&"
export * from "./WordDetailMobile.vue?vue&type=script&lang=js&"
import style0 from "./WordDetailMobile.vue?vue&type=style&index=0&id=1a891efa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a891efa",
  null
  
)

export default component.exports